import {
	GET_ACTIVE_ALARMS,
	GET_ACTIVE_ALARMS_SUCCESS,
	GET_ACTIVE_ALARMS_FAIL,
	ACK_ACTIVE_ALARM,
	ACK_ACTIVE_ALARM_SUCCESS,
	ACK_ACTIVE_ALARM_FAIL,
	RESET_ACK_STATE,
	GET_ACTIVE_ALARMS_CRITICAL,
	GET_ACTIVE_ALARMS_CRITICAL_SUCCESS,
	GET_ACTIVE_ALARMS_CRITICAL_FAIL,
	GET_ACTIVE_ALARMS_MAJOR,
	GET_ACTIVE_ALARMS_MAJOR_SUCCESS,
	GET_ACTIVE_ALARMS_MAJOR_FAIL,
	GET_ACTIVE_ALARMS_MINOR,
	GET_ACTIVE_ALARMS_MINOR_SUCCESS,
	GET_ACTIVE_ALARMS_MINOR_FAIL,
	GET_ADMIN_ACCOUNT_DETAILS,
	GET_ADMIN_ACCOUNT_DETAILS_SUCCESS,
	GET_ADMIN_ACCOUNT_DETAILS_FAIL,
	ALARMS_COUNT_REQUEST_GET,
	ALARMS_COUNT_RESPONSE_GET_SUCCESS,
	ALARMS_COUNT_RESPONSE_GET_FAIL,
} from '../../constants/maintenance/activeAlarmsConstants';

/**
 * Reducer function for managing active alarms list.
 *
 * @param {object} state - Current state of the active alarms list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */

export const activeAlarmsReducer = (state = { activeAlarms: [] }, action) => {
	switch (action.type) {
		case GET_ACTIVE_ALARMS:
			return {
				...state,
				activeAlarms : [],
				loading: true,
			};
		case GET_ACTIVE_ALARMS_SUCCESS:
			return {
				...state,
				loading: false,
				activeAlarms: action.payload,
			};
		case GET_ACTIVE_ALARMS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const activeAlarmsCriticalReducer = (state = { activeAlarmsCritical: [] }, action) => {
	switch (action.type) {
		case GET_ACTIVE_ALARMS_CRITICAL:
			return {
				...state,
				loading: true,
			};
		case GET_ACTIVE_ALARMS_CRITICAL_SUCCESS:
			return {
				...state,
				loading: false,
				activeAlarmsCritical: action.payload,
			};
		case GET_ACTIVE_ALARMS_CRITICAL_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const activeAlarmsMajorReducer = (state = { activeAlarmsMajor: [] }, action) => {
	switch (action.type) {
		case GET_ACTIVE_ALARMS_MAJOR:
			return {
				...state,
				loading: true,
			};
		case GET_ACTIVE_ALARMS_MAJOR_SUCCESS:
			return {
				...state,
				loading: false,
				activeAlarmsMajor: action.payload,
			};
		case GET_ACTIVE_ALARMS_MAJOR_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const activeAlarmsMinorReducer = (state = { activeAlarmsMinor: [] }, action) => {
	switch (action.type) {
		case GET_ACTIVE_ALARMS_MINOR:
			return {
				...state,
				loading: true,
			};
		case GET_ACTIVE_ALARMS_MINOR_SUCCESS:
			return {
				...state,
				loading: false,
				activeAlarmsMinor: action.payload,
			};
		case GET_ACTIVE_ALARMS_MINOR_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};



export const ackActiveAlarmsReducer = (
	state = { ackSuccess: null, ackError: null },
	action
) => {
	switch (action.type) {
		case ACK_ACTIVE_ALARM:
			return {
				...state,
				loading: true,
			};
		case ACK_ACTIVE_ALARM_SUCCESS:
			return {
				...state,
				loading: false,
				ackSuccess: action.payload,
			};
		case ACK_ACTIVE_ALARM_FAIL:
			return {
				...state,
				loading: false,
				ackError: action.payload,
			};
		case RESET_ACK_STATE:
			return {
				...state,
				loading: false,
				ackError: null,
				ackSuccess: null,
			};
		default:
			return state;
	}
};

export const adminAccountDetailsReducer = (state = { adminAccountDetail: {} }, action) => {
	switch (action.type) {
	  case GET_ADMIN_ACCOUNT_DETAILS:
		return {
		  ...state,
		  loading: true,
		};
	  case GET_ADMIN_ACCOUNT_DETAILS_SUCCESS:
		return {
		  ...state,
		  loading: false,
		  adminAccountDetail: action.payload,
		};
	  case GET_ADMIN_ACCOUNT_DETAILS_FAIL:
		return {
		  ...state,
		  loading: false,
		  error: action.payload,
		};
	  default:
		return state;
	}
  };

  export const devicesAlarmsCountReducer = (state = { alarmsCount: {} }, action) => {
	switch (action.type) {
	  case ALARMS_COUNT_REQUEST_GET:
		return {
		  ...state,
		  loading: true,
		};
	  case ALARMS_COUNT_RESPONSE_GET_SUCCESS:
		return {
		  ...state,
		  loading: false,
		  alarmsCount: action.payload,
		};
	  case ALARMS_COUNT_RESPONSE_GET_FAIL:
		return {
		  ...state,
		  loading: false,
		  error: action.payload,
		};
	  default:
		return state;
	}
  };